import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export type BadgeVariant = "success" | "warning" | "error" | "info" | "neutral" | "cycle";

const VARIANT_STYLES: Record<BadgeVariant, string> = {
  success: "bg-emerald-50 text-emerald-700",
  warning: "bg-amber-50 text-amber-700",
  error: "bg-rose-50 text-rose-700",
  info: "bg-indigo-50 text-indigo-700",
  neutral: "bg-gray-100 text-gray-600",
  cycle: "bg-fuchsia-50 text-fuchsia-700",
};

const SIZE_STYLES = {
  sm: "px-2 py-0.5 text-[9px]",
  md: "px-2.5 py-1 text-[10px]",
};

interface StatusBadgeProps {
  variant: BadgeVariant;
  children: ReactNode;
  size?: "sm" | "md";
  className?: string;
}

export function StatusBadge({ variant, children, size = "md", className }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full font-black uppercase tracking-widest",
        VARIANT_STYLES[variant],
        SIZE_STYLES[size],
        className,
      )}
    >
      {children}
    </span>
  );
}
